//@flow

export const INFORMATION_BLOCK_LAYOUT_TYPE = {
  TEXT_IMAGE: 'TEXT_IMAGE',
  TEXT_LIST: 'TEXT_LIST',
  COLLAPSIBLE: 'COLLAPSIBLE',
};
